import { connect } from 'react-redux';
import Home from './Home';

import { updateRoute, activateTransition } from 'redux/actions';

const mapStateToProps = state => ({
  viewport: state.app.viewport,
  transitionActive: state.app.transitionActive,
});

const mapDispatchToProps = {
  updateRoute,
  activateTransition,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
